import { createContext } from "react";
import { useSnackbar } from "notistack";

//spec for logging => https://www.notion.so/reactlabs/Logging-Spec-e68e96abecb5430890c7e465cb7c2b4f

export const ErrorManagementContext = createContext();

const ErrorManagementProvider = ({ children }) => {

  const { enqueueSnackbar } = useSnackbar();
  /**
   * General function for ventralized loggin the cookclubapp
   * @param {String} message The MEssage that will be displayed
   * @param {String} eventType The event type this shoudl be a astring without space
   * @param {object} eventData Additional Event Data
   * @param {object} settings settings determine where the logs should go
   */
  function cookClubLog(
    message,
    eventType,
    eventData,
    settings = { ui: { type: "default" } }
  ) {
    if (message !== '') {
      message = `: ${message}`
    }
    const { ui, browserConsole } = settings;
    if (ui)
      enqueueSnackbar(`${eventType}${message}`, {
        variant: ui?.type ? ui.type : "default", autoHideDuration: 1500
      });
    if (browserConsole) console.log(eventType, message);
  }
  return (
    <ErrorManagementContext.Provider value={{ cookClubLog }}>
      {children}
    </ErrorManagementContext.Provider>
  );
};

ErrorManagementProvider.propTypes = {};

export default ErrorManagementProvider;
